import React, { PureComponent } from 'react';
import bytes from 'bytes';
// import Drift from 'react-driftjs';
import { scroller } from 'react-scroll/modules';

import {
  BadgeAd,
  BannerAd,
  Button,
  PdfResizer,
  ResponsiveTable,
  ScrollWindow,
  PdfScaler
} from 'components';
import { simplifyUrl } from 'utils';
import withPageTracking from 'hoc/withPageTracking';
import {PdfSizes} from 'modules';

import CloseIcon from 'assets/icons/close.svg';

import styles from './styles';

class PdfAdjust extends PureComponent {

  constructor(props) {
    super(props);

    let pdfSizes = {};
    PdfSizes.forEach(v => {
      pdfSizes[v.value] = v.label;
    })

    this.state = {
      size: {type: "predefined", size: "100"},
      scale: {scale: true, keepAspect: true},
      fileSizeSuffix: 'kb',
      quality: '100',
      format: '',
      resizeMultiplier: null,
      resizeWidth: null,
      resizeHeight: null,
      pdfSizes,
      sizes: {}
    };
  }
  
  handleScallerOptionChange = (options) => this.setState({scale: options.scale});

  handleResizeOptionChange = (options) => this.setState({size: options.size});

  getNewSize = (size) => {
    if(size.type === 'predefined') {
      return this.state.pdfSizes[size.size];
    } else {
      return size.width + 'x' + size.height + ' ' + size.suffix;
    }
  }
  resizeImages = () => {
    let {bulkImages, resizeImages} = this.props;
    const {
      size,
      scale
    } = this.state;

    // bulkImages = [];
    const $this = this;
    resizeImages(bulkImages.map((image) => {
      console.log('iamge id '+image.imageId)
      const body = {
        imageId: image.imageId,
        oldSizes: image.oldSizes,
        pdfResize: size,
        pdfScale: scale,
        newSize: $this.getNewSize(size)
      };
      return body;
    }));
  };

  scrollToResizeSettings = () => {
    scroller.scrollTo('resizeSettings', {
      duration: 500,
      smooth: true
    });
  };


  getAction({ imageId }) {
    console.log('image id' + imageId) ///here getting the image correctly
    const {removeImage} = this.props;

    return (
      <Button
        onClick={removeImage}
        clickProps={[imageId]}
      >
        <CloseIcon height="20" width="20" />
      </Button>
    );
  }

  renderList() {
    const {bulkImages} = this.props;
    console.log(bulkImages);
    const columns = {
      fileName: {
        filter: simplifyUrl,
        grow: true,
        heading: 'File Name'
      },
      pageSize: {
        heading: 'Current Page Size',
        width: '150px'
      },
      originalSize: {
        heading: 'File Size',
        width: '130px'
      },
      action: {
        heading: 'Remove',
        width: '80px'
      }
    };
    const rows = bulkImages.map((image) => 
    ({
      fileName: image.name,
      pageSize: Math.round((image.oldSizes.width / 72) * 25.4) + 'x' + Math.round((image.oldSizes.height  / 72) * 25.4) + ' mm',
      // size: bytes(image.contentLength),
      originalSize: bytes(image.contentLength),
      action: this.getAction(image)
    }));

    return (
      <ScrollWindow
        label="Resize Settings"
        onClick={ this.scrollToResizeSettings }
      >
        <ResponsiveTable
          columns={ columns }
          rows={ rows }
          type="default"
        />
      </ScrollWindow>
    );
  }

  render() {
    const {fileSize, fileSizeSuffix, quality, format} = this.state;

    return (
      <div className='sideBySide container greenIcon'>
        {/* <Drift appId="rzyr4ptivr3s" /> */}
        <div className='maxWidthSection'>
          <div className={`section ${styles.noTopPadding}`}>
            {this.renderList()}
          </div>
          <div
            className='section'
            ref={ (elem) => {
              scroller.register('resizeSettings', elem);
            } }
          >
            <h2><span className='step'>1</span> Select Paper Size</h2>
            <PdfResizer onOptionChange={this.handleResizeOptionChange} />
          </div>
          
          <div className='section'>
            <h2><span className='step'>2</span> Scale (Optional)</h2>
            <PdfScaler
              showFileSizeInput="yes"
              fileSize={fileSize}
              fileSizeSuffix={fileSizeSuffix}
              quality={quality}
              format={format}
              onOptionChange={this.handleScallerOptionChange}
            />
          </div>
          <BannerAd />
          <div className='section'>
            <Button
              className='main-button'
              onClick={this.resizeImages}
            >
              Resize PDF
            </Button>
          </div>
        </div>
        <BadgeAd />
      </div>
    );
  }
}

export default withPageTracking(PdfAdjust, '/bulk-editor.html');



// WEBPACK FOOTER //
// ./src/containers/PdfResize/PdfAdjust.jsx